// Base URL
// export const BASE_URL = 'http://13.53.215.254/'; //aws  
// export const BASE_URL = 'https://portal.fitmatch.mobi';
//export const BASE_URL = 'https://admin.snachme.com/Backend';
export const BASE_URL = 'https://tandemly.nexusappdevelopers.com';
// export const BASE_URL = 'http://127.0.0.1:8000';


// Tab-hidden logout: if user closes/switches away from the tab and doesn't return
// within this many minutes, they are logged out when they come back.
// Override with .env: REACT_APP_IDLE_LOGOUT_MINUTES=15
export const IDLE_LOGOUT_MINUTES = parseInt(
  process.env.REACT_APP_IDLE_LOGOUT_MINUTES || '40',
  10
);

// User Role
export const SUPER_ADMIN = "super-admin";
export const COURT_USER = "court-user";